@if (course) {
<!-- ══ TOP BAR (minimal, sin distracciones) ══ -->
<nav class="lp-nav" [class.scrolled]="isScrolled">
  <a routerLink="/" class="lp-nav-logo" aria-label="Inicio Grupo Gaeli">
    <img src="grupogaeli_logo.png" alt="Grupo Gaeli" class="lp-nav-logo-img" />
  </a>
  <a [href]="waLink" target="_blank" rel="noopener noreferrer" class="lp-nav-wa">
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
    <span>Escríbenos</span>
  </a>
</nav>

<!-- ══ HERO ══ -->
<header class="lp-hero">
  <div class="lp-hero-inner">
    <div class="lp-tag">{{ course.tag }}</div>
    <h1>{{ course.title }}</h1>
    <p class="lp-hero-sub">{{ course.subtitle }}</p>
    <p class="lp-hero-desc">{{ course.description }}</p>

    <div class="lp-pills">
      <span class="lp-pill">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
        100% virtual
      </span>
      <span class="lp-pill">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
        Certificación incluida
      </span>
      <span class="lp-pill">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
        Acompañamiento experto
      </span>
    </div>

    @if (priceLabel) {
      <div class="lp-price">
        <span class="lp-price-label">Inversión</span>
        <span class="lp-price-value">{{ priceLabel }}</span>
      </div>
    }

    <div class="lp-hero-cta">
      <a [href]="waLink" target="_blank" rel="noopener noreferrer" class="lp-btn-wa">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
        Más información por WhatsApp
      </a>
      <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="lp-btn-ghost">Quiero inscribirme</a>
    </div>
    <p class="lp-hero-note">Respuesta rápida · Sin compromiso · Te asesoramos paso a paso</p>
  </div>
</header>

<!-- ══ OBJETIVO + TEMARIO ══ -->
<section class="lp-section">
  <div class="lp-two-col">
    <div class="lp-objetivo reveal">
      <div class="lp-section-label">El objetivo</div>
      <h2>¿Para qué te prepara este diplomado?</h2>
      <p>{{ course.objetivo }}</p>
      <a [href]="waLink" target="_blank" rel="noopener noreferrer" class="lp-inline-link">
        Pregúntanos cómo aplica a tu caso →
      </a>
    </div>

    <div class="lp-learn reveal reveal-delay-1">
      <div class="lp-section-label">Lo que aprenderás</div>
      <ul>
        @for (item of course.aprenderas; track item) {
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
            {{ item }}
          </li>
        }
      </ul>
    </div>
  </div>
</section>

<!-- ══ VALOR ══ -->
<section class="lp-section lp-section--dark">
  <div class="lp-section-label lp-section-label--light">{{ course.valueLabel }}</div>
  <h2 class="lp-h2-light">Lo que ganas al certificarte</h2>
  <div class="lp-value-grid">
    @for (v of course.valueTags; track v) {
      <div class="lp-value-card reveal">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
        <span>{{ v }}</span>
      </div>
    }
  </div>
</section>

<!-- ══ METODOLOGÍA ══ -->
<section class="lp-section">
  <div class="lp-section-label">Metodología</div>
  <h2>Una formación práctica y acompañada</h2>
  <div class="lp-metod">
    <div class="lp-metod-item reveal">
      <div class="lp-metod-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 10l4.553-2.069A1 1 0 0121 8.845v6.31a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/></svg></div>
      <span>Clases virtuales</span>
    </div>
    <div class="lp-metod-item reveal reveal-delay-1">
      <div class="lp-metod-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/></svg></div>
      <span>Material descargable</span>
    </div>
    <div class="lp-metod-item reveal reveal-delay-2">
      <div class="lp-metod-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/></svg></div>
      <span>Casos prácticos</span>
    </div>
    <div class="lp-metod-item reveal reveal-delay-3">
      <div class="lp-metod-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg></div>
      <span>Evaluaciones</span>
    </div>
    <div class="lp-metod-item reveal reveal-delay-4">
      <div class="lp-metod-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg></div>
      <span>Acompañamiento permanente</span>
    </div>
  </div>
</section>

<!-- ══ CTA FINAL ══ -->
<section class="lp-final">
  <div class="lp-final-icon">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
  </div>
  <h2>¿Listo para dar el siguiente paso?</h2>
  <p>Escríbenos por WhatsApp y un asesor te dará toda la información del diplomado <strong>{{ course.title }}</strong>: fechas, inversión, modalidad y proceso de inscripción.</p>
  @if (priceLabel) {
    <p class="lp-final-price">Inversión: <strong>{{ priceLabel }}</strong></p>
  }
  <a [href]="waLink" target="_blank" rel="noopener noreferrer" class="lp-btn-wa lp-btn-wa--white">
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
    Hablar con un asesor ahora
  </a>
</section>

<!-- ══ OTROS PROGRAMAS ══ -->
<section class="lp-section lp-others">
  <div class="lp-section-label">Otros diplomados</div>
  <h2>Explora más programas de GAELI Academy</h2>
  <div class="lp-others-grid">
    @for (oc of otherCourses; track oc.slug) {
      <a [routerLink]="['/cursos', oc.slug]" class="lp-other-card reveal">
        <div class="lp-other-tag">{{ oc.tag }}</div>
        <h3>{{ oc.title }}</h3>
        @if (oc.price != null) {
          <span class="lp-other-price">{{ formatPrice(oc.price) }}</span>
        }
        <span class="lp-other-link">Ver diplomado →</span>
      </a>
    }
  </div>
</section>

<!-- ══ FOOTER ══ -->
<footer class="lp-footer">
  <a routerLink="/" class="lp-footer-logo">
    <img src="grupogaeli_logo.png" alt="Grupo Gaeli" />
  </a>
  <p>GAELI Academy — Formación virtual certificada en sistemas de gestión, calidad y sostenibilidad.</p>
  <div class="lp-footer-links">
    <a [href]="waLink" target="_blank" rel="noopener noreferrer">WhatsApp: +57 320 306 4734</a>
    <a href="mailto:info@grupogaeli.com">info&#64;grupogaeli.com</a>
    <a routerLink="/">Sitio web</a>
  </div>
  <span class="lp-footer-copy">© 2025 Grupo GAELI S.A.S. · Bucaramanga, Colombia</span>
</footer>

<!-- ══ BOTÓN FLOTANTE WHATSAPP ══ -->
<a [href]="waLink" target="_blank" rel="noopener noreferrer" class="lp-fab" aria-label="Más información por WhatsApp">
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
  <span class="lp-fab-label">¿Dudas? Escríbenos</span>
</a>
}
